export default __webpack_public_path__ + "static/fa-brands-400-d4365dc3cb3333233aadd6c3b2d1efbb.svg";